import $ from 'jquery'
import {orgText} from '../cads/cache/get'

const redisVpoOrgIds = [2]
const skipVpoOrgIds = [5, 7]

const getVendorOrders = (orgId, callback) => {
  if (skipVpoOrgIds.includes(orgId)) {
    callback([])
    return
  }

  if (redisVpoOrgIds.includes(orgId)) {
    $.get(process.env.REACT_APP_API_URL + '/api/get_vpo_data/?org_id='+orgId, function (result) {
      callback(JSON.parse(result.data))
    })
    return
  }

  let randomNum = Math.floor(Math.random()*99999999).toString()
  let url = 'https://' + process.env.REACT_APP_S3_BUCKET_NAME + '.s3.amazonaws.com/caches/vpos' + orgText(orgId) + '.json?t=' + randomNum

  $.get(url, function (result) {
    let data = typeof result === 'string' ? JSON.parse(result) : result
    callback(data)
  })
}

export {getVendorOrders} 
